import mission1 from "@/images/missions/mission1.png"
import mission2 from "@/images/missions/mission2.png"
import mission3 from "@/images/missions/mission3.png"
import mission4 from "@/images/missions/mission4.png"

const missionThumbnails = [mission1, mission2, mission3, mission4]

export function getChallengeThumbnail(index: number) {
  return missionThumbnails[index % missionThumbnails.length]
}

export type Difficulty = "Easy" | "Medium" | "Hard" | "Elite"

export interface ChallengeMeta {
  category: string
  difficulty: Difficulty
}

// How many stars (out of 4) each difficulty fills in the detail panel.
export const difficultyStars: Record<Difficulty, number> = {
  Easy: 1,
  Medium: 2,
  Hard: 3,
  Elite: 4,
}

export const difficultyChipStyles: Record<Difficulty, string> = {
  Easy: "border-emerald-300/40 bg-emerald-500/15 text-emerald-200",
  Medium: "border-sky-300/40 bg-sky-500/15 text-sky-200",
  Hard: "border-amber-300/45 bg-amber-500/15 text-amber-200",
  Elite: "border-fuchsia-300/45 bg-fuchsia-500/15 text-fuchsia-200",
}

// Derive a category + difficulty from the challenge so each mission carries
// meaningful, game-flavoured metadata instead of a generic "Mission" tag.
export function getChallengeMeta(challenge: IChallenge): ChallengeMeta {
  const id = challenge.id
  if (id.includes("bankrupt")) return { category: "Domination", difficulty: "Hard" }
  if (id.includes("networth")) return { category: "Tycoon", difficulty: "Elite" }
  if (id.includes("rent-lord")) return { category: "Strategy", difficulty: "Hard" }
  if (id.includes("stock") || id.includes("wall-street")) return { category: "Investor", difficulty: "Elite" }
  if (id.includes("opponents")) return { category: "Comeback", difficulty: "Hard" }
  if (id.includes("round-completion")) return { category: "Hardcore", difficulty: "Hard" }
  if (id.includes("negative") || id.includes("300")) return { category: "Survival", difficulty: "Hard" }
  if (id.includes("1000") || id.includes("1200")) return { category: "Survival", difficulty: "Medium" }
  return { category: "Mission", difficulty: "Medium" }
}
